﻿(function ($) {
    //Decalare in Global Namespace	
    window.M2 = window.M2 || {};
    window.M2.Media = {};

    // Private Variables
    var version = "1.0";
    var author = "esg";

    function setGallery() {
        $(document).on("click", ".cover-gallery a", function (e) {
            e.preventDefault();
            var galleryImage = $(this).data("gallery-image");
            var galleryType = $(this).data("gallery-type");
            var galleryUrl = $(this).attr("href");
            $(".product-viewer img").attr("src", galleryImage);

            switch(galleryType) {
                case "image":
                    $(".product-viewer a").removeAttr("href").removeClass("modal clickable");
                    break;
                case "local-video":
                    $(".product-viewer a").attr("data-target", galleryUrl).addClass("modal clickable");
                    break;
                case "external-link":
                    $(".product-viewer a").attr({ "href": galleryUrl, "target": "_blank" }).removeClass("modal").addClass("clickable");
                    break;
            }
        });
    }

    M2.Media = {
        config: {
            name: "M2 Media Viewer"
        },
        init: function () {
            setGallery();
        }
    };
})(jQuery);

$(function () {
    M2.Media.init();
});